import { notification } from 'antd'

import B2becTranslation from '@/components/B2becTranslation'

const MAX_TOASTS = 3
const TOAST_DISPLAY_TIME = 3.75

/**
 * Check if a value is a string (to distinguish between i18n keys and ReactNodes)
 */
const isStringValue = (value) => typeof value === 'string'

const getConfigs = ({
  message,
  description,
  variables,
  descriptionVars,
  ...rest
}) => {
  // Build message component: use B2becTranslation for string keys, pass ReactNode directly
  const MessageComponent = message
    ? isStringValue(message)
      ? <B2becTranslation value={message} variables={variables} />
      : message
    : null

  // Build description component: use B2becTranslation for string keys, pass ReactNode directly
  const DescriptionComponent = description
    ? isStringValue(description)
      ? <B2becTranslation value={description} variables={descriptionVars || variables} />
      : description
    : null

  const configs = {
    duration: TOAST_DISPLAY_TIME,
    maxCount: MAX_TOASTS,
    message: MessageComponent,
    description: DescriptionComponent,
    ...rest,
  }

  return configs
}

const success = (props) => notification.success({ ...getConfigs(props) })
const info = (props) => notification.info({ ...getConfigs(props) })
const warning = (props) => notification.warning({ ...getConfigs(props) })
const error = (props) => notification.error({ ...getConfigs(props) })

export const NotificationManager = {
  success,
  info,
  warning,
  error,
}
